export default __webpack_public_path__ + "static/media/UdunkuluLogo.11d8d85a.svg";